import { useComparisonTableDropdownIndices } from '@/decodo/blocks/ProductComparisonTable/comparisonUtils/utils';
import Badge from '@/decodo/components/atoms/badge';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import { Text } from '@/decodo/components/atoms/Text';
import { RefObject } from 'react';

interface ProductType {
  isBestValue?: boolean;
  productIcon?: ImageStrapiProps;
  productTitle?: string;
}

interface SelectedDataItem {
  productType?: ProductType;
}

interface ComparisonGridHeaderProps {
  selectedData: (SelectedDataItem | null)[];
  headerRefs: RefObject<(HTMLDivElement | null)[]>;
  stickyOffsetTop?: number;
}

export const ComparisonGridHeader = ({
  selectedData,
  headerRefs,
  stickyOffsetTop = 0,
}: ComparisonGridHeaderProps) => {
  const visibleItemsCount = selectedData.filter(Boolean).length;

  const dropdownIndices = useComparisonTableDropdownIndices();
  return (
    <div className='bg-gray-25 grid grid-cols-[160px_repeat(3,_minmax(200px,_1fr))] pt-3'>
      <div />
      {dropdownIndices.map((i) => {
        const { isBestValue } = selectedData[i]?.productType || {};
        return (
          <div
            key={`badge-${i}`}
            ref={(el: HTMLDivElement | null) => {
              headerRefs.current[i] = el;
            }}
            className='bg-gray-25 sticky flex flex-col pl-12'
            style={{ top: stickyOffsetTop }}
          >
            {isBestValue && (
              <Badge size='s' colors='success-100' variant='filled'>
                Best value
              </Badge>
            )}
          </div>
        );
      })}

      <div />
      {dropdownIndices.map((i) => {
        const shouldHide = visibleItemsCount === 1 && i === 2;
        const shouldShowDash = i >= visibleItemsCount;

        if (shouldHide) return null;

        if (shouldShowDash) {
          return (
            <div
              key={`product-${i}`}
              className='bg-gray-25 sticky flex flex-col py-2 pl-12'
              style={{ top: stickyOffsetTop + 72 }}
            >
              <Text className='text-body-m text-base-black font-serif'>–</Text>
            </div>
          );
        }

        const { productIcon, productTitle } =
          selectedData[i]?.productType || {};

        return (
          <div
            key={`product-${i}`}
            ref={(el: HTMLDivElement | null) => {
              headerRefs.current[i] = el;
            }}
            className='bg-gray-25 sticky flex flex-col py-2 pl-12'
            style={{ top: stickyOffsetTop }}
          >
            {productTitle && (
              <div className='flex items-center gap-x-3 pb-5 pt-2'>
                {productIcon && (
                  <ImageStrapi
                    block={productIcon}
                    inner={{ classNames: { image: 'w-8 h-8' } }}
                  />
                )}
                <Text className='text-h4 text-base-black font-serif'>
                  {productTitle}
                </Text>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
